import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PLATFORM_API_URL } from '../constants';
import { GetUsersDTO } from '../model';

@Injectable()
export class GraphApiService {
  private readonly http = inject(HttpClient);
  private readonly platformApiUrl = inject(PLATFORM_API_URL);

  public getAllUsers(): Observable<GetUsersDTO> {
    return this.http.post<GetUsersDTO>(`${this.getBaseUrl()}/GetUsersByGroupNames`, ['InboundFax']);
  }

  private getBaseUrl(): string {
    return `${this.platformApiUrl}/api/Graph`;
  }
}
